export default __webpack_public_path__ + "static/media/general-people.14200a12.png";